module.exports = __webpack_public_path__ + "static/media/IMG_3732.b81dd256.jpg";